import { RouterStateUrl } from '@mnz-core/modules/store/router-store.serializer';
import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getData = createSelector(
  getRouterState,
  ({ state }) => state.data
);

export const getParams = createSelector(
  getRouterState,
  ({ state }) => state.params
);

export const getQueryParams = createSelector(
  getRouterState,
  ({ state }) => state.queryParams
);

export const isYellowBgEnabled = createSelector(
  getData,
  data => data && data.yellowBg
);
